import React from "react";

export default class VendorItemDashboardSearchWidget extends React.Component<{
    onChange: (keyword: string) => void;
    value: string;
}> {
    render(): React.ReactNode {
        return (
            <div className="relative flex-grow w-full">
                <input
                    type="text"
                    placeholder="Cari Vendor"
                    className="h-9 px-2 block appearance-none w-full bg-white border border-gray-300 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => this.props.onChange(e.target.value)}
                    value={this.props.value}
                />
            </div>
        );
    }
}
